module.exports = __webpack_public_path__ + "img/12.7d286b70.png";